<claas-app-section-header>
  <h2 class="section-title">{{ productTitle() }}</h2>
  <button
    [disabled]="!productCompetitors()"
    class="competitor-comparison-button"
    (click)="setShowMainModal(true)"
  >
    <claas-icon
      [id]="''"
      [iconId]="'1008871'"
      [namespace]="'storybook'"
      [iconStyle]="'bold'"
      [size]="24"
      [alt]=""
      [iconName]="'favorites'"
      [removeDefaultColor]="true"
      [class]="'favorites-icon'"
    >
    </claas-icon>
    <span class="competitor-comparison-button-text font-m">{{
      "features.product-arguments-product-techdata-overview.competitorComparisonButton"
        | translate
    }}</span>
  </button>
  <claas-main-modal-dialog [(show)]="showMainModal"
    ><claas-competitor-selection-dialog
      (closeCompetitorsDialog)="setShowMainModal(false)"
  /></claas-main-modal-dialog>
</claas-app-section-header>

<div class="app-section-container">
  <nav class="tabs" mat-tab-nav-bar [tabPanel]="tabPanel">
    <a
      mat-tab-link
      [routerLink]="[
        argumentsTabActive()
          ? './'
          : `../../arguments/${$safeNavigationMigration(routeParams()?.['productId'])}`,
      ]"
      routerLinkActive
      [active]="argumentsTabActive()"
    >
      Arguments
    </a>

    <a
      mat-tab-link
      [routerLink]="[
        techDataTabActive()
          ? './'
          : `../../tech-data/${$safeNavigationMigration(routeParams()?.['productId'])}`,
      ]"
      routerLinkActive
      [active]="techDataTabActive()"
      >Tech Data</a
    >
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
